/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'unicorn',
    quality: 0.7,
    magicalGravity: 1.5
}